import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import {
    Button,
    DialogTitle,
    DialogContent,
    Grid,
    TextField,
    DialogActions,
    Dialog
} from '@material-ui/core';
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http'
import Toast from '../../Layout/components/Toast';
import ClientAutoComplete from '../../Components/ClientAutoComplete';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import Client from "./Client";
import { ADD, EDIT, roleStr } from "../../../common/common";

const Root = styled(Dialog)({
    width: '100%',
    '& .MuiGrid-item': {
        padding: '4px 12px'
    },
    '& .table': {
        width: '750px',
    },
    '& .textWapper': {
        width: '750px',
        '& .add-new': {
            marginTop: '10px'
        },
    },
});

class ContactInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // data: {
            //     client_id: 0,
            //     other_client_id: 0,//选现有的才要此项
            //     first_name: "gou",
            //     last_name: "bi",
            //     full_name: "gou bi",
            //     relation: "ceo",
            //     email: "12345678@qq.com",
            //     phone: "13322223333",
            //     wechat: "goubijiushini",
            //     note: "ss",
            // },
            open: false,
            openCreate: false,
            clientObj: null,
            client_id: "",
            contact_id: "",
            relation: "",
            note: "",
            dialogTitle: "Add new individual client",
            dialogState: ADD,
            dialogData: null,
            showToast: false,
            toastMsg: "",
            toastState: "",
            crtIndex: 0,
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateTempBy = this.updateTempBy.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.openAddModal = this.openAddModal.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }

    render() {
        const { isAdd } = this.props;
        const {
            open,
            openCreate,
            relation,
            clientObj,
            dialogTitle,
            dialogData,
            dialogState,

            showToast,
            toastMsg,
            toastState,
        } = this.state;
        return (
            <Root open={open} onClose={this.handleClose} aria-labelledby="form-dialog-title" className="editor">
                <DialogTitle id="form-dialog-title">
                    <div className="editor-title">ADD CONTACT</div>
                </DialogTitle>
                <DialogContent dividers spacing={3}>
                    <div className="textWapper">
                        <Grid container>
                            <Grid item xs={12} sm={8}>
                                <ClientAutoComplete
                                    allClient={false}
                                    initClient={clientObj}
                                    update={this.updateTempBy}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Button className="add-new" color="primary" onClick={this.openAddModal}><AddIcon />Add
                                    new client</Button>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    margin="dense"
                                    label="Title"
                                    name="relation"
                                    value={relation}
                                    fullWidth
                                    onChange={e => this.handleChange(e)}
                                />
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleClose()}>
                        Cancel
                    </Button>
                    <Button onClick={() => this.handleClose(isAdd)} variant="contained" color="primary">
                        Save
                    </Button>
                </DialogActions>
                <Dialog maxWidth={false} open={openCreate}>
                    <Client
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={dialogData}
                        state={dialogState}
                        hideType={true}
                        ICType={0}
                    />
                </Dialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                />
            </Root>
        )
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        const {
            open,
            data,
            isAdd,
        } = this.props;

        if (prevProps.open !== open) {
            if (open) {
                console.log(data);
                if (!isAdd && data) {
                    this.setState({
                        open: true,
                        clientObj: {
                            individual: {
                                first_name: data.client.first_name,
                                last_name: data.client.last_name,
                                full_name: data.client.first_name + " " + data.client.last_name,
                                email: data.client.email,
                                phone: data.client.phone,
                                wechat: data.client.wechat,
                            },
                            id: data.client_id
                        },
                        relation: data.relation,
                        crtIndex: data.index,
                        contact_id: data.contact_id,
                    });
                } else {
                    this.setState({
                        open: true,
                        clientObj: null,
                        relation: "",
                    });
                }

            } else {
                this.setState({
                    open
                });
            }
        }
    }

    initEditor() {
    }

    handleClose(isAdd) {
        const { onClose } = this.props;
        if (typeof onClose !== 'function') {
            console.error("onClose is not a function");
            return
        }
        if (isAdd !== null) {
            const { contact_id, client_id, clientObj, relation, crtIndex } = this.state;
            if (!clientObj) {
                this.showToast("Please select a contact", "warning");
                return;
            }
            if (!relation || relation === "") {
                this.showToast("Please fill in the relation", "warning");
                return;
            }
            if (isAdd) {
                onClose(ADD, {
                    client_id: client_id,
                    client: clientObj.individual,
                    relation,
                });
            } else {
                onClose(EDIT, {
                    index: crtIndex,
                    contact_id: contact_id,
                    client_id: client_id,
                    client: clientObj.individual,
                    relation,
                });
            }
        } else {
            onClose();
        }
    }

    handleChange(e) {
        const { value, name } = e.target;
        this.setState(() => ({
            [name]: value
        }));
    }

    handleCreate(radioValue, obj) {
        console.log(radioValue, obj);
        this.addIndividual(obj, (id) => {
            this.setState(() => ({
                clientObj: {
                    individual: {
                        first_name: obj.first_name,
                        last_name: obj.last_name,
                        full_name: obj.first_name + " " + obj.last_name,
                        email: obj.email,
                        phone: obj.phone,
                        wechat: obj.wechat,
                    },
                    id: id
                },
                client_id: id,
                openCreate: false,
            }));
            this.showToast("Added successfully", "success");
        });
    }

    handleCancel() {
        this.setState(() => ({
            openCreate: false,
        }));
    }

    openAddModal() {
        this.setState(() => ({
            openCreate: true,
        }));
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }

    updateTempBy(clientObj) {
        if (clientObj) {
            this.setState(() => ({
                client_id: clientObj.id,
                clientObj
            }))
        }
    }

    addIndividual(obj, callback) {
        const params = {
            first_name: obj.first_name,
            last_name: obj.last_name,
            email: obj.email,
            phone: obj.phone,
            wechat: obj.wechat,
            referral_source: obj.referral_source,
            note: obj.note,
            handlers: obj.handlers,
        };
        instance.post(BASE_URL + roleStr() + '/clients/individual', params).then((res) => {
            console.log("创建", res);
            const client_id = res.data.data.id;
            callback(client_id);
            this.iApproval(client_id);
        }).catch((err) => {
            if (!err.response) {
                this.showToast("unknown error", "error");
            }
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    // TODO: unsuitable api needs modification
    iApproval(client_id) {
        const params = {
            state: "audited",
        };
        console.log("params", params);
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/individual', params).then((res) => {
            console.log("审核", res)
        }).catch((err) => {
            if (!err.response) {
                this.showToast("unknown error", "error");
            }
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default ContactInfo;